
import { Box, Container, Typography } from "@mui/material";

const Unauthorized = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        bgcolor: "#ffffff",
      }}
    >
      {/* Top header bar */}
      <Box
        sx={{
          bgcolor: "#ffffff",
          py: { xs: 4, md: 5 },
          px: 3,
          textAlign: "center",
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        <Typography
          variant="h4"
          component="h1"
          sx={{
            fontWeight: 500,
            color: "#2c2c2c",
            fontSize: { xs: "1.5rem", md: "2rem" },
            mb: 1,
          }}
        >
          Access Restricted
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: "#6b6b6b",
            fontSize: { xs: "0.9rem", md: "1rem" },
          }}
        >
          Access to 99gift.ae has been blocked because you appear to
          be connected to a VPN or proxy.
        </Typography>
      </Box>

      {/* Main content */}
      <Container
        maxWidth="lg"
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          py: { xs: 4, md: 6 },
          textAlign: "center",
        }}
      >
        <Box
          component="img"
          src="https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/QGPgFzIWSmXV3XYfGQ9C3CcAPzNm6Kz3GFGDaYsE.jpg"
          alt="Access restricted due to VPN connection"
          sx={{
            width: "100%",
            maxWidth: { xs: "100%", md: 700, lg: 900 },
            height: "auto",
            objectFit: "contain",
            display: "block",
            mb: 3,
          }}
        />

        <Typography
          variant="h6"
          component="h2"
          sx={{
            fontWeight: 500,
            color: "#2c2c2c",
            mb: 1,
          }}
        >
          Please Disconnect Your VPN
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: "#6b6b6b",
            maxWidth: 600,
            lineHeight: 1.8,
            fontSize: { xs: "0.9rem", md: "1rem" },
          }}
        >
          For security reasons, access to this website is not
          permitted while using a VPN or proxy connection. Please
          disconnect your VPN and try again.

          If you are not using a VPN, please contact our support
          team for assistance.
        </Typography>
      </Container>
    </Box>
  );
};

export default Unauthorized;
